import React, { useEffect, useState } from 'react';
import { Bubble, Table } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import GameImage from '@/pages/home/components/GameImage';
import {
  valueFormat,
  growthFormat,
  sortPermissionList,
} from '@/pages/home/pages/home/Explore/_config/common';
import ValueGrowth from '@/pages/home/pages/home/components/ValueGrowth';
import { useIntl } from 'umi';
import { filterable } from 'tea-component/es/table/addons/filterable'; // fix filterable白屏问题
import { gotoDashboardGame, getDashboardGamePath } from '@/pages/home/utils/utils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';

const {
  sortable,
  // filterable,
  scrollable,
  selectable,
} = Table.addons;

const sorterFunc = (first: any, second: any, name: string, order: string) => {
  const firstVal = parseFloat(first[name]);
  const secondVal = parseFloat(second[name]);
  /** 升序、降序： 空值放最后 */
  if (isNaN(firstVal)) {
    return order === 'asc' ? 1 : -1;
  }
  if (isNaN(secondVal)) {
    return order === 'asc' ? -1 : 1;
  }
  return firstVal - secondVal;
};

export default function ExploreTable(props: any) {
  const { formatMessage, locale } = useIntl(); // 中英切换方法
  const {
    segVal,
    options,
    tableData = [],
    selectedKeys: selectedKeysProps,
    handleTableCheck,
    maxGameNum,
    dashboardPageinfoList,
  } = props;

  const [selectedKeys, setSelectedKeys] = useState<any>([]);
  const [selectedOldKeys, setSelectedOldKeys] = useState([]);
  const [gameFilterActive, setGameFilterActive] = useState(false);
  const [regionFilterActive, setRegionFilterActive] = useState(false);
  const [phaseFilterActive, setPhaseFilterActive] = useState(false);
  // 当前排序列
  const [sorts, setSorts] = useState([
    {
      /** 默认按dau排序，后端已返回的是今天的前一天了，没必要前端再做成前一天 */
      by: 'dau',
      order: 'desc',
      sorter: (first: any, second: any) =>
        sorterFunc(first, second, 'dau', 'desc'),
    },
  ]);

  const [phaseOptions, setPhaseOptions] = useState<any[]>([]);
  const [regionOptions, setRegionOptions] = useState<any[]>([]);
  const [gameVal, setGameVal] = useState<any>();
  const [phaseVal, setPhaseVal] = useState<any>();
  const [regionVal, setRegionVal] = useState<any>();

  const [columns, setColumns] = useState<any[]>([]);
  let filteredRecords = tableData?.slice();
  filteredRecords?.sort(sortable?.comparer(sorts));
  filteredRecords = sortPermissionList(filteredRecords);
  // 代码迁移： 经分添加自定义id，前端排序变化，id不变
  for (let i = 0;i < filteredRecords?.length;i++) {
    filteredRecords[i].iegid = i + 1;
  }

  const handleDataFormat = (cvm: any, params: any) => {
    const { segVal } = params;
    // const value = mathFormat(cvm[segVal])
    let value: any = '';
    if (['arpu', 'arppu'].includes(segVal)) {
      value = +cvm[segVal] ? (+cvm[segVal]).toFixed(2) : '-';
    } else if (['d2', 'pay_permeability'].includes(segVal)) {
      value = +cvm[segVal] ? `${(+cvm[segVal]).toFixed(2)}%` : '-';
    } else {
      value = valueFormat(cvm[segVal]);
    }

    const rate = cvm[`${segVal}_rate`] || '-';
    const growthDataObj = growthFormat(rate, false);

    return {
      value: value,
      type: growthDataObj.type,
      growth: growthDataObj.value,
    };
  };

  const getTipsData = (keyValue: string) => {
    // 24.6.13 lynn修改首页Revenue($)的指标解释，由于Revenue($)在其他地方使用，因此用一个新的key给首页使用
    let keyValueTmp = keyValue;
    const newRevenueKeyEn = 'Revenue($)_home';
    const newRevenueKeyCn = '付费金额($)_home';
    // 当keyValue === 'Revenue($)'，并且dashboardPageinfoList有值时，才判断是否有'Revenue($)_home'的key，否则用原有key
    if (Array.isArray(dashboardPageinfoList) && dashboardPageinfoList?.length > 0) {
      if (keyValue === 'Revenue($)' || keyValue === '付费金额($)') {
        const newRevenueKey = keyValue === 'Revenue($)' ? newRevenueKeyEn : newRevenueKeyCn;
        if (dashboardPageinfoList?.findIndex((item: any) => item.key === newRevenueKey) > -1) {
          keyValueTmp = newRevenueKey;
        }
      }
    }
    const keyText = dashboardPageinfoList?.find((item: any) => item.key == keyValueTmp)?.value || '';
    if (keyValueTmp === 'D2(T-1)' || keyValueTmp === '次留(T-1)') {
      return formatMessage({ id: 'dbh_search_dashboard_tip_t_1' });
    }
    return keyText?.replaceAll('\\n', '<br/>');
  };

  useEffect(() => {
    const _phaseOptions: any[] = [];
    const _regionOptions: any[] = [];
    tableData?.forEach((item: any) => {
      const _phaseVal = _phaseOptions.filter((t) => {
        return t.text === item.game_phase;
      });
      if (_phaseVal.length < 1 && item.game_phase) {
        _phaseOptions.push({
          text: item.game_phase,
          value: item.game_phase,
        });
      }
      const _regionVal = _regionOptions.filter((t) => {
        return t.text === item.game_region;
      });
      if (_regionVal.length < 1 && item.game_region) {
        _regionOptions.push({
          text: item.game_region,
          value: item.game_region,
        });
      }
    });
    setPhaseOptions(_phaseOptions);
    setRegionOptions(_regionOptions);

    const _columns: any[] = [
      // { key: "select", header: null, width: 26, fixed: "left" },
      {
        key: 'game',
        header: (
          <div className="table-flex-ft">
            <span className="table-flex-num">#</span>
            {formatMessage({ id: 'dbh_metric_game' })}
            <SvgIcon
              className={
                gameFilterActive
                  ? 'table-change-actionicon'
                  : 'table-change-icon'
              }
              type="funnel"
            />
          </div>
        ),
        width: 300,
        fixed: 'left',
        render: (cvm: any) => (
          <ARightClickToJump
            href={getDashboardGamePath(cvm?.game)}
          // style={{ display: 'inline' }}
          >
            <div
              className="table-flex"
              onClick={() => {
                gotoDashboardGame(cvm?.game);
              }}
            >
              <div className="table-flex-num">{cvm?.iegid}</div>
              <div className="table-flex-imgcontent">
                <div className="table-flex-img">
                  <GameImage src={cvm?.cover} moduleType={'dashboard'} />
                  {cvm?.cbtTag && (
                    <span className="table-flex-texticon">CBT</span>
                  )}
                  {cvm?.newTag && (
                    <span className="table-flex-texticon">NEW</span>
                  )}
                </div>
              </div>
              <div className="table-flex-title">
                <div className="table-flex-game">{cvm?.game_name_cn}</div>
                <div className="table-flex-text">{cvm?.game_name_en}</div>
              </div>
            </div>
          </ARightClickToJump>
        ),
      },
      {
        key: 'game_region',
        header: (
          <div className="table-change-flex">
            {formatMessage({ id: 'dbh_metric_region' })}
            {/* table-change-actionicon 选中样式 */}
            <SvgIcon
              className={
                regionFilterActive
                  ? 'table-change-actionicon'
                  : 'table-change-icon'
              }
              type="funnel"
            />
          </div>
        ),
        width: 100,
        align: 'left',
        render: (cvm: any) => <div>{cvm?.game_region}</div>,
      },
      {
        key: 'game_phase',
        align: 'left',
        header: (
          <div className="table-change-flex">
            {formatMessage({ id: 'dbh_metric_phase' })}
            {/* table-change-actionicon 选中样式 */}
            <SvgIcon
              className={
                phaseFilterActive
                  ? 'table-change-actionicon'
                  : 'table-change-icon'
              }
              type="funnel"
            />
          </div>
        ),
        width: 100,
        render: (cvm: any) => <div>{cvm?.game_phase}</div>,
      },
    ];
    const isCN = locale === LANGUAGE_CN;
    options.forEach((e: any) => {
      const width = isCN ? e?.cnWidth : e?.enWidth;
      _columns.push({
        key: e.value,
        header: () => {
          return (
            <Bubble
              arrowPointAtCenter
              dark
              style={{ maxWidth: 420 }}
              content={<div dangerouslySetInnerHTML={{ __html: getTipsData(e.text) }}></div>}
            >
              {e.text}
            </Bubble>
          );
        },
        width: width || 150,
        align: 'right',
        render: (cvm: any) => {
          let _cvm = cvm;
          // New Users字段特殊处理
          _cvm = handleDataFormat(cvm, {
            segVal: e.value === 'new_users' ? 'new' : e.value,
          });
          const hasPermission = cvm?.has_permission ?? true;
          return (
            <div className="table-culm">
              <ValueGrowth
                value={_cvm?.value}
                type={_cvm?.type /* "up" : "down"*/}
                growth={_cvm?.growth}
                hasPermission={hasPermission}
                preClassName="table-culm"
              />
            </div>
          );
        },
      });
    });
    setColumns(_columns);
  }, [
    segVal,
    gameFilterActive,
    phaseFilterActive,
    regionFilterActive,
    JSON.stringify(tableData),
    locale,
    dashboardPageinfoList,
  ]);

  useEffect(() => {
    setSelectedKeys(selectedKeysProps);
  }, [selectedKeysProps]);

  if (gameVal && gameVal !== 'ALL_VALUE') {
    // 筛选打标游戏
    filteredRecords = filteredRecords.filter((x) => x.cbtTag || x.newTag);
  }
  if (phaseVal && phaseVal !== 'ALL_VALUE') {
    filteredRecords = filteredRecords.filter((x) => x.game_phase === phaseVal);
  }
  if (regionVal && regionVal !== 'ALL_VALUE') {
    filteredRecords = filteredRecords.filter(
      (x) => x.game_region === regionVal,
    );
  }

  return (
    <>
      <Table
        records={filteredRecords}
        recordKey={'game'}
        // records={[...tableData].sort(sortable.comparer(sorts))}
        bordered="all"
        className="home-gametable home-gametable-dashboard"
        columns={columns}
        addons={[
          scrollable({
            maxHeight: 392,
            minWidth: 1100,
            // onScrollBottom: () => console.log("到达底部"),
          }),
          selectable({
            // 禁用全选
            all: false,
            // 已选中的键值
            value: selectedKeys,
            rowSelect: false,
            onChange: (keys, _context) => {
              if (keys?.length === 0) {
                setSelectedOldKeys(selectedKeys);
              } else if (keys?.length === 1) {
                setSelectedKeys([...selectedOldKeys, ...keys]);
                handleTableCheck([...selectedOldKeys, ...keys]);
              } else {
                setSelectedKeys(keys);
                handleTableCheck(keys);
              }
              setSelectedOldKeys([]);
            },
            // targetColumnKey: "game",
            rowSelectable: (keys) => {
              const flag = selectedKeys?.includes(keys);
              if (selectedKeys?.length >= maxGameNum) {
                return flag;
              } else {
                return true;
              }
            },
            render: (e: any, record) => {
              const isSelected = selectedKeys?.includes(record.rowKey);
              const isDisable = selectedKeys?.length >= maxGameNum;
              return (
                <Bubble
                  dark
                  content={
                    isDisable && !isSelected
                      ? formatMessage({ id: 'dbh_table_disablegame_tip' })
                      : null
                  }
                >
                  {e}
                </Bubble>
              );
            },
          }),
          // 支持表格排序
          sortable({
            // 支持排序的列，默认点第一下为desc
            columns: [
              'dau',
              'revenue',
              'd2',
              'new_users',
              'arpu',
              'arppu',
              'pay_permeability',
              'payer',
              'pcu',
              'aot',
              'tru',
            ].map((e) => ({ key: e, prefer: 'desc', sorter: (_f, _s) => 0 })),
            value: sorts,
            onChange: (value, _context) => {
              /** 按某一指标排序后，其他指标边上icon恢复默认状态 */
              if (value?.length > 0) {
                const { by, order } = value[0];
                // 新进用户前端按new_users为key来映射，趋势图后端也是返回new_users
                // 但是宽表接口返回的key是new, 排序时需要替换使用new来排序
                const sortField = by === 'new_users' ? 'new' : by;
                setSorts([{
                  by,
                  order,
                  sorter: (first, second) =>
                    sorterFunc(first, second, sortField, order),
                }]);
              } else {
                setSorts([]);
                /* 如果想要点击时只有上升和下降2个状态可以打开下面代码
                if (sorts?.length > 0) {
                  let newSortOpt = sorts[0];
                  newSortOpt.order = sorts[0]?.order === 'desc' ? 'asc' : 'desc';
                  newSortOpt.sorter = (first, second) => sorterFunc(first, second, newSortOpt.by, newSortOpt.order)
                  setSorts([newSortOpt])
                }else{
                  setSorts([])
                }*/
              }
            },
          }),
          filterable({
            type: 'single',
            column: 'game',
            value: gameVal,
            onChange: (value) => {
              setGameVal(value);
              if (value === 'ALL_VALUE') {
                setGameFilterActive(false);
              } else {
                setGameFilterActive(true);
              }
            },
            all: {
              value: 'ALL_VALUE',
              text: 'ALL',
            },
            options: [
              {
                value: 'newgame',
                text: 'New Game',
              },
            ],
          }),
          filterable({
            type: 'single',
            column: 'game_region',
            value: regionVal,
            onChange: (value) => {
              setRegionVal(value);
              if (value === 'ALL_VALUE') {
                setRegionFilterActive(false);
              } else {
                setRegionFilterActive(true);
              }
            },
            all: {
              value: 'ALL_VALUE',
              text: 'ALL',
            },
            options: regionOptions,
          }),
          filterable({
            type: 'single',
            column: 'game_phase',
            value: phaseVal,
            onChange: (value) => {
              setPhaseVal(value);
              if (value === 'ALL_VALUE') {
                setPhaseFilterActive(false);
              } else {
                setPhaseFilterActive(true);
              }
            },
            all: {
              value: 'ALL_VALUE',
              text: 'ALL',
            },
            options: phaseOptions,
          }),

        ]}
      />
    </>
  );
}
